import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const Navbar = ({ title, backTo, backLabel, actions }) => {
  const navigate = useNavigate();
  const { user, logout } = useUser();

  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to log out?')) {
      await logout();
      navigate('/');
    }
  };

  return (
    <nav style={styles.nav}>
      <div style={styles.inner}>
        {/* Left */}
        <div style={styles.left}>
          {backTo && (
            <button style={styles.backBtn} onClick={() => navigate(backTo)}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M15 18l-6-6 6-6"/>
              </svg>
              <span style={styles.backLabel}>{backLabel || 'Back'}</span>
            </button>
          )}
          {!backTo && (
            <div style={styles.brand}>
              <div style={styles.logoBox}>
                <img src="/logo.png" alt="Logo" style={styles.brandLogo}
                  onError={e => { e.target.parentElement.style.display = 'none'; }} />
              </div>
              <span style={styles.brandName}>Jain University</span>
            </div>
          )}
        </div>

        {/* Center */}
        {title && <div style={styles.title}>{title}</div>}

        {/* Right */}
        <div style={styles.right}>
          {actions}
          {user && (
            <div style={styles.userArea}>
              <span style={styles.userName}>{user.name?.split(' ')[0]}</span>
              <button style={styles.logoutBtn} onClick={handleLogout}>
                Sign out
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

const styles = {
  nav: {
    background: 'rgba(255,255,255,0.8)',
    backdropFilter: 'blur(16px)',
    WebkitBackdropFilter: 'blur(16px)',
    borderBottom: '1px solid rgba(99,102,241,0.12)',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  inner: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 20px',
    height: 68,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    flex: '0 0 auto',
  },
  backBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    background: 'none',
    border: 'none',
    color: '#6366f1',
    fontWeight: 600,
    fontSize: 14,
    cursor: 'pointer',
    padding: '6px 10px 6px 4px',
    borderRadius: 8,
  },
  backLabel: {
    display: 'block',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  logoBox: {
    flexShrink: 0,
  },
  brandLogo: {
    height: 44,
    width: 'auto',
    display: 'block',
  },
  brandName: {
    fontSize: 15,
    fontWeight: 700,
    color: '#1e1b4b',
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
    color: '#1e1b4b',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    flex: '0 0 auto',
  },
  userArea: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  userName: {
    fontSize: 14,
    fontWeight: 600,
    color: '#374151',
  },
  logoutBtn: {
    background: 'none',
    border: '1.5px solid #e5e7eb',
    borderRadius: 8,
    padding: '5px 12px',
    fontSize: 13,
    fontWeight: 600,
    color: '#6b7280',
    cursor: 'pointer',
  },
};

export default Navbar;
